export const normalizeFolderPath = (path) => (path || "").replace(/\/+$/, "");

export const isDefaultDraftReportsPath = (path) => {
  const parts = normalizeFolderPath(path).split("/");
  return parts.length === 2 && parts[1].toLowerCase() === "draft reports";
};

export const sanitizeFolderName = (name) =>
  typeof name === "string"
    ? name.replace(/[<>:"|?*\\/\x00-\x1f\x7f]/g, "").replace(/\s+/g, " ").trim()
    : "";

export const isValidFolderName = (name) => name !== "" && name !== "." && name !== "..";

export function findFolder(nodes, path) {
  const target = normalizeFolderPath(path);
  for (const node of nodes || []) {
    if (normalizeFolderPath(node.path) === target) return node;
    const found = findFolder(node.children, path);
    if (found) return found;
  }
  return null;
}

export function hasDuplicateFolder(nodes, path, name) {
  const target = normalizeFolderPath(path);
  const parentPath = target.split("/").slice(0, -1).join("/");
  const siblings = findFolder(nodes, parentPath)?.children || [];
  return siblings.some(
    (node) =>
      node.fileType === "folder" &&
      normalizeFolderPath(node.path) !== target &&
      typeof node.name === "string" &&
      node.name.trim().toLowerCase() === name.toLowerCase(),
  );
}

export function renameFolderTree(nodes, oldPath, newPath) {
  const oldBase = normalizeFolderPath(oldPath);
  const newBase = normalizeFolderPath(newPath);
  return (nodes || []).map((node) => {
    const path = normalizeFolderPath(node.path);
    const updated = { ...node };
    if (path === oldBase || path.startsWith(oldBase + "/")) {
      updated.path = newBase + path.slice(oldBase.length) + (node.path.endsWith("/") ? "/" : "");
      if (path === oldBase) {
        updated.name = newBase.split("/").pop();
        updated.title = updated.name;
        updated.editing = false;
        delete updated.status;
      }
    }
    if (node.children) updated.children = renameFolderTree(node.children, oldPath, newPath);
    return updated;
  });
}

export function addFolderTree(nodes, parentPath, name, editing = false) {
  return (nodes || []).map((node) => {
    if (normalizeFolderPath(node.path) === normalizeFolderPath(parentPath)) {
      return {
        ...node,
        expanded: true,
        children: [
          ...(node.children || []),
          {
            name,
            title: name,
            path: `${normalizeFolderPath(parentPath)}/${name}/`,
            fileType: "folder",
            children: [],
            expanded: true,
            editing,
            ...(editing ? { status: "new" } : {}),
          },
        ],
      };
    }
    return node.children ? { ...node, children: addFolderTree(node.children, parentPath, name, editing) } : node;
  });
}

export function removeFolderTree(nodes, path) {
  return (nodes || [])
    .filter((node) => normalizeFolderPath(node.path) !== normalizeFolderPath(path))
    .map((node) => (node.children ? { ...node, children: removeFolderTree(node.children, path) } : node));
}